import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=03f673f6&"
import script from "./FileSelect.vue?vue&type=script&lang=js&"
export * from "./FileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f673f6')) {
      api.createRecord('03f673f6', component.options)
    } else {
      api.reload('03f673f6', component.options)
    }
    module.hot.accept("./FileSelect.vue?vue&type=template&id=03f673f6&", function () {
      api.rerender('03f673f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/FileSelect.vue"
export default component.exports